import React, { Component } from "react";
import { createPortal } from "react-dom";
import { Button } from "antd";
import Panel from "../../../components/Panel";
import { SetupInputGroupItem } from "../AMIModel/SetupComponents/SetupInputGroup";
import { getSettingDataList } from "../../../services/Andes_v2/simulation";
import libraryConstructor from "../../../services/Andes_v2/library/libraryConstructor";
import { CPHY_EYE_MASK, USER_DEFINED_NETLIST } from "../../../constants/libraryConstants";

const defaultSetting = {
  symbolRate: "1 Gsps",
  initialDelay: "0 nsec",
  timeStep: "0.01 nsec",
  cycles: 200,
  hspiceCores: 2,
  eyeMask: { libraryId: "" },
  userDefinedNetlist: { libraryId: "" },
  eyePlotConfig: { waveform_start: "", waveform_end: "", ui_before_trigger: "1", ui_after_trigger: "0" },
}

/**
 * @param {{
 *  hspiceConfig,channelId,libraryStatus,_updateHSPICEConfig,closePanel,
 * }} props
 * @returns
 */
class SettingPanel extends Component {
  constructor() {
    super();
    this.state = {
      settingInfo: {},
      eyeMaskList: libraryConstructor.getLibraryValues(CPHY_EYE_MASK),
      userDefinedNetlistList: libraryConstructor.getLibraryValues(USER_DEFINED_NETLIST),
    };
    this.dialogRoot = document.getElementById("root");
  }

  componentDidMount() {
    const { hspiceConfig = {} } = this.props;
    this.setState({
      settingInfo: {
        ...defaultSetting,
        symbolRate: hspiceConfig.symbolRate,
        initialDelay: hspiceConfig.initialDelay,
        timeStep: hspiceConfig.timeStep,
        cycles: hspiceConfig.cycles,
        hspiceCores: hspiceConfig.hspiceCores,
        eyeMask: hspiceConfig.eyeMask,
        userDefinedNetlist: hspiceConfig.userDefinedNetlist,
        testMode: hspiceConfig.testMode,
        enableSElement: hspiceConfig.enableSElement,
        eyePlotConfig: hspiceConfig.eyePlotConfig,
      },
    });
  }

  componentDidUpdate(prevProps) {
    const { libraryStatus } = this.props;
    if (prevProps.libraryStatus !== libraryStatus) {
      this.setState({
        eyeMaskList: libraryConstructor.getLibraryValues(CPHY_EYE_MASK),
        userDefinedNetlistList: libraryConstructor.getLibraryValues(USER_DEFINED_NETLIST),
      })
    }
  }

  inputChange = (type, value) => {
    const { settingInfo } = this.state;
    let _value = value;
    if (['eyeMask', 'userDefinedNetlist'].includes(type)) {
      const libraryType = type === 'eyeMask' ? CPHY_EYE_MASK : USER_DEFINED_NETLIST;
      const libraryInfo = libraryConstructor.getLibrary(libraryType, value) || {};
      _value = {
        libraryId: value,
        fileName: libraryInfo.name,
      };
    }
    this.setState({
      settingInfo: {
        ...settingInfo,
        [type]: _value,
      },
    });
  };

  closeModal = () => {
    const { hspiceConfig } = this.props;
    const { settingInfo } = this.state;
    this.props._updateHSPICEConfig({
      ...hspiceConfig,
      ...settingInfo,
    });
    this.props.closePanel();
  };

  clickSimulate = () => {
    const { settingInfo } = this.state;
    const { channelId, channelLoading, hspiceConfig } = this.props;
    if (channelLoading) return;
    this.props._updateHSPICEConfig(
      {
        ...hspiceConfig,
        ...settingInfo,
      },
      channelId
    );
    this.props.closePanel();
  };

  footerRender = () => {
    return <div className="andes-v2-panel-footer-center-button">
      <Button type="primary" size="small" onClick={() => this.clickSimulate()}>
        Simulate
      </Button>
    </div>
  }

  render() {
    const { channelType } = this.props;
    const { settingInfo, eyeMaskList, userDefinedNetlistList } = this.state;
    const content = (
      <Panel
        className="andes-v2-model-panel andes-v2-hspice-simulation-setting-panel"
        position="panel-center-left"
        title="HSPICE Simulation"
        zIndex={2000}
        onCancel={() => this.closeModal()}
        minWidth={660}
        width={710}
        draggable
        minHeight={200}
        footer={this.footerRender()}
      >
        <div className="andes-v2-hspice-simulation-setting-model-content">
          <SetupInputGroupItem
            dataList={getSettingDataList(settingInfo, eyeMaskList, userDefinedNetlistList, channelType)}
            onChange={this.inputChange}
          />
        </div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }
}

export default SettingPanel